import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { PartnerStatus } from 'clickNgo/entities/partner/configs'

import { invalidatePartnerDataCache } from './cache'
import { changePartnerStatus } from './changePartnerStatus'

interface ICancelPartnerInactivationRequestParams {
  partnerId: string
  locationId: string
}

export const cancelPartnerInactivationRequest = async ({
  partnerId,
  locationId,
}: ICancelPartnerInactivationRequestParams) => {
  const response = await changePartnerStatus({
    locationId,
    status: PartnerStatus.Active,
    source: ProfilingRequestSource.ClickAndGo,
  })

  if (response.status === 'success') {
    invalidatePartnerDataCache(partnerId)
  }

  return response
}
